module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido@3x-41388f168845de3734d82b56d7ec4ec9.webp";